import { __assign, __read, __rest } from "tslib";
import React, { useRef, useState, useMemo, useCallback, useEffect, } from "react";
import classNames from "classnames";
import { TableHead } from "./TableHead";
import { TableBody } from "./TableBody";
import { useMiddleware } from "./util/use-middleware";
import { createRocket } from "../_util/create-rocket";
import { useConfig } from "../_util/config-context";
import { TableContext } from "./TableContext";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import * as addons from "./addons";
import { mergeEventProps } from "../_util/merge-event-props";
export var Table = forwardRefWithStatics(function Table(props, ref) {
    var classPrefix = useConfig().classPrefix;
    var _a = __read(useState("left"), 2), scrollStatus = _a[0], setScrollStatus = _a[1];
    var _b = __read(useState([]), 2), columnsWidths = _b[0], setColumnsWidths = _b[1];
    var _c = props.addons, addons = _c === void 0 ? [] : _c, bordered = props.bordered, compact = props.compact, verticalTop = props.verticalTop;
    var headRef = useRef(null);
    var bodyRef = useRef(null);
    // 执行 addon props middleware
    // eslint-disable-next-line no-param-reassign
    props = useMiddleware(addons, "onInjectProps")(props);
    var hasFixedColumn = useMemo(function () { return props.columns.find(function (column) { return !!column.fixed; }); }, [props.columns]);
    // 同步 body 和 header 滚动位置
    var handleScroll = useCallback(function () {
        // 设置水平滚动状态（固定列样式）
        if (bodyRef.current && hasFixedColumn) {
            var _a = bodyRef.current, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth, scrollLeft = _a.scrollLeft;
            var atLeft = scrollLeft === 0;
            var atRight = scrollWidth <= Math.ceil(clientWidth + scrollLeft);
            if (atLeft && atRight) {
                setScrollStatus("no-scroll");
            }
            else if (atLeft) {
                setScrollStatus("left");
            }
            else if (atRight) {
                setScrollStatus("right");
            }
            else {
                setScrollStatus("scrolling");
            }
        }
        if (headRef.current && bodyRef.current) {
            headRef.current.scrollLeft = bodyRef.current.scrollLeft;
        }
    }, [hasFixedColumn]);
    useEffect(function () {
        handleScroll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columnsWidths]);
    var renderTable = useMiddleware(addons, "onInjectTable")(function (_a) {
        var _b;
        var className = _a.className, style = _a.style, props = __rest(_a, ["className", "style"]);
        return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-table", className, (_b = {},
                _b[classPrefix + "-table--compact"] = compact,
                _b[classPrefix + "-table--bordered"] = bordered,
                _b[classPrefix + "-table--allbordered"] = bordered === "all",
                _b[classPrefix + "-table--verticaltop"] = verticalTop,
                _b)), style: style }, mergeEventProps(props)),
            React.createElement(TableContext.Provider, { value: { scrollStatus: scrollStatus, columnsWidths: columnsWidths } },
                React.createElement(TableHead, __assign({ ref: headRef }, props, { onResize: setColumnsWidths })),
                React.createElement(TableBody, __assign({ ref: bodyRef, onScrollCapture: handleScroll, onResize: setColumnsWidths }, props)))));
    });
    return renderTable(props);
}, {
    addons: addons,
    ActionPanel: createRocket("ActionPanel", "div.@{prefix}-table__action-panel"),
});
Table.displayName = "Table";
//# sourceMappingURL=Table.js.map